import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { FileDoc, FilePdf } from "@bw/icons"

const Download = styled.a`
  display: grid;
  grid-template-columns: 34px 1fr;
  grid-column-gap: 12px;
  width: 100%;
  text-decoration: none;
  border-radius: 26px;
  padding: 10px 20px 10px 15px;
  box-shadow: none;
  background-color: var(--neutral-background);
  color: var(--text-color);
  transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out;

  &:hover {
    background-color: var(--primary);
    box-shadow: 0px 15px 25px rgba(0, 33, 209, 0.15);
    color: #fff;
  }
`

const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  align-self: center;
`

const Excerpt = styled.p`
  font-size: 13px;
  line-height: 1.2;
  margin: 0;
  grid-column: 2 / 3;
  white-space: pre-wrap;
`

const IconWrapper = styled.div`
  width: 34px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0px 0px 25px rgba(11, 23, 40, 0.15);
`

function getExtension(filename) {
  return filename.split(".").pop()
}

const File = ({ title, description, href, hover }) => {
  let filename = href
  let extension = getExtension(filename)

  return (
    <Download download href={href} target="_blank">
      <IconWrapper>
        {extension === "pdf" ? (
          <FilePdf fillColor="var(--primary)" />
        ) : (
          <FileDoc fillColor="var(--primary)" />
        )}
      </IconWrapper>
      <Title>{title}</Title>
      {description && <Excerpt>{description}</Excerpt>}
    </Download>
  )
}

File.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  href: PropTypes.string,
  hover: PropTypes.bool,
}

File.defaultProps = {
  hover: false,
}

export { File }
